module.exports = __webpack_public_path__ + "static/media/logo.b5a185f3.svg";